<template>
  <div class="dialog-mask" @click.self="handleClose">
    <div class="dialog-content" @click.stop>
      <div>
        <button class="close-button" type="button" @click="handleClose">
          <span class="close-icon">×</span>
        </button>
      </div>
      <div class="dialog-body">
        <div class="cat-icon-container">
          <CatIcon :clickable="false" size="large" writerType="IMPS" />
        </div>
        <div class="description">
          <p>{{ $t("myPage.writerTypeIndicatorSkipConfirmDialog.description") }}</p>
          <p>{{ $t("myPage.writerTypeIndicatorSkipConfirmDialog.confirmQuestion") }}</p>
          <p class="note">{{ $t("myPage.writerTypeIndicatorSkipConfirmDialog.note") }}</p>
        </div>
        <div class="button-wrapper">
          <button class="btn-skip" @click="handleSkip">
            {{ $t("myPage.writerTypeIndicatorSkipConfirmDialog.skipButton") }}
          </button>
          <button class="btn-cancel" @click="handleClose">
            {{ $t("myPage.writerTypeIndicatorSkipConfirmDialog.cancelButton") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    CatIcon,
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleSkip() {
      try {
        await this.$store.dispatch("assistantCatModule/createAssistantCatMasterOnSkip");
        this.$notify({
          title: this.$t("myPage.writerTypeIndicatorSkipConfirmDialog.successMessage") as string,
          type: "success",
        });
        this.$emit("done");
        this.$emit("close");
      } catch (error) {
        console.error("Failed to skip writer type indicator:", error);
        this.$notify({
          title: this.$t("myPage.writerTypeIndicatorSkipConfirmDialog.errorMessage") as string,
          type: "error",
        });
      }
    },
  },
});

interface Data {}

interface Methods {
  handleClose: () => void;
  handleSkip: () => Promise<void>;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
  padding: 20px;
  z-index: 9000;
}

.dialog-content {
  background: var(--color-background-normal);
  border-radius: var(--radius-md);
  max-width: 360px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  box-shadow: var(--shadow-lg);
  color: var(--color-text-normal);
}

.close-button {
  background: none;
  border: none;
  font-size: var(--font-size-xl);
  cursor: pointer;
  color: var(--color-text-low);
  padding: 4px;
  border-radius: var(--radius-xs);
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 10000;

  @include hover-overlay;
}

.close-icon {
  font-weight: var(--font-weight-bold);
  line-height: 1;
}

.dialog-body {
  padding: 20px;
  text-align: center;
}

.cat-icon-container {
  display: flex;
  justify-content: center;

  .cat-icon {
    background: var(--color-surface-muted);
    padding: 12px;
  }
}

.description {
  text-align: left;
  font-size: var(--font-size-sm);
  margin-top: 20px;

  p {
    margin: 0;
  }

  .note {
    margin-top: 20px;
    font-size: var(--font-size-xs);
    color: var(--color-text-low);
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 20px;

  button {
    width: 100%;
    max-width: 280px;
    padding: 10px 16px;
    font-size: var(--font-size-sm);
    border-radius: var(--radius-lg);
    cursor: pointer;
  }
}

.btn-skip {
  background: var(--color-primary);
  color: var(--color-text-on-fixed-bg);
  border: none;
  font-weight: var(--font-weight-bold);
}

.btn-cancel {
  color: var(--color-text-normal);
  border: none;
  background: var(--color-surface-muted);
  font-weight: var(--font-weight-bold);
}
</style>
